import React from "react";
import FormView from "../components/E2E/FormView";

function FormPage() {
  return (
    <div>
      <main>
        <FormView />
      </main>
    </div>
  );
}

export default FormPage;